import AnalyticsActions from '@Actions/application/analyticsActions';
import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Image from '@Uilib/h3Image';
import H3Text from '@Uilib/h3Text';
import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button, Collapse, Divider, Drawer,
  InputNumber,
  Select,
  Table,
} from 'antd';
import Lottie from 'lottie-react';
import React, {
  Fragment, useEffect, useMemo, useState,
} from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import LabelGenerationActions from '../../../actions/configurations/labelGenerationActions';
import successLottie from '../../../media/lotties/success.json';
import GlobalLabelsCard from '../../Admin/AdminConfiguration/LabelGeneration/GlobalLabelsCard';
import {
  handleChangeCopiesHelper, handleChangeProductCopiesHelper, productsAndBatchInfoHelper,
} from './helpers';
import './style.scss';
import PRZSelect from '../UI/PRZSelect';

function DownloadLabels({
  isModalOpen, toggleModal, documentType, documentId, labelGeneration, getLabelGeneration, user, setIsLabelAvailable, selectedGRN, getLabelGenerationLoading, selectedMO, selectedInvoice, printedLabels, printLabelsLoading, printLabels, printLabelsSuccess,
}) {
  const [labelTemplateId, setLabelTemplateId] = useState(null);
  const [selectedLabel, setSelectedLabel] = useState('');
  const [productsAndBatchInfo, setProductsAndBatchInfo] = useState([]);
  const [fgProductsAndBatchInfo, setFgProductsAndBatchInfo] = useState([]);
  const [resetCopies, setResetCopies] = useState(false);
  const { Panel } = Collapse;

  useEffect(() => {
    const payload = {
      tenantId: user?.tenant_info?.tenant_id,
      entityName: documentType,
    };
    getLabelGeneration(payload, (_data) => {
      if (_data.data?.length) {
        setIsLabelAvailable(true);
      }
    });
    return () => {

    };
  }, []);

  useEffect(() => {
    if (labelGeneration) {
      setLabelTemplateId(labelGeneration?.[0]?.label_template_id);
      setSelectedLabel(labelGeneration?.[0]);
    }
  }, [labelGeneration]);

  useEffect(() => {
    if (selectedGRN) {
      const tempProductsAndBatchInfo = productsAndBatchInfoHelper(selectedGRN, 'grn_lines', 'product_sku_info', 'product_batches');
      setProductsAndBatchInfo(tempProductsAndBatchInfo);
    }

    if (selectedMO) {
      const tempRMProductsAndBatchInfo = productsAndBatchInfoHelper(selectedMO, 'mo_lines', 'tenant_product_info', 'raw_material_adjustments');
      const tempFGProductsAndBatchInfo = productsAndBatchInfoHelper(selectedMO, 'mo_finished_goods', 'tenant_product_info', 'finished_good_adjustments');
      setFgProductsAndBatchInfo(tempFGProductsAndBatchInfo)
      setProductsAndBatchInfo(tempRMProductsAndBatchInfo);
    }

    if (selectedInvoice) {
      const tempProductsAndBatchInfo = productsAndBatchInfoHelper(selectedInvoice, 'invoice_lines', 'product_sku_info', 'product_batches');
      setProductsAndBatchInfo(tempProductsAndBatchInfo);
    }
  }, [selectedGRN, selectedMO, selectedInvoice, resetCopies]);

  const handleChangeCopies = (value, childKey, parentKey) => {
    const tempProductsAndBatchInfo = handleChangeCopiesHelper(productsAndBatchInfo, value, childKey, parentKey);
    setProductsAndBatchInfo(tempProductsAndBatchInfo);

    const tempFGProductsAndBatchInfo = handleChangeCopiesHelper(fgProductsAndBatchInfo, value, childKey, parentKey);
    setFgProductsAndBatchInfo(tempFGProductsAndBatchInfo);
  };

  const handleChangeProductCopies = (value, key) => {
    const tempProductsAndBatchInfo = handleChangeProductCopiesHelper(productsAndBatchInfo, value, key);
    setProductsAndBatchInfo(tempProductsAndBatchInfo);

    const tempFGProductsAndBatchInfo = handleChangeProductCopiesHelper(fgProductsAndBatchInfo, value, key);
    setFgProductsAndBatchInfo(tempFGProductsAndBatchInfo);
  };

  const getBatchInfoColumns = () => {
    const columns = [
      {
        title: 'Batch Number',
        render: (record) => (record?.custom_batch_number),
      },
      {
        title: 'Copies',
        width: 210,
        render: (record) => (
          <InputNumber
            type="number"
            min={0}
            changeOnWheel={false}
            controls={false}
            style={{
              width: 200,
            }}
            formatter={(value) => `${value}`.replace(/[^0-9]/g, '')}
            parser={(value) => value.replace(/[^\d]/g, '')}
            value={record?.copies}
            onChange={(value) => {
              handleChangeCopies(value, record?.key, record?.parentKey);
            }}
          />
        ),
      },
    ];

    return columns;
  };

  const getBatchInfoData = (data, parentKey) => data?.map((batchInfo) => ({
    ...batchInfo,
    parentKey,
  }));

  const countBatchCopies = useMemo(() => [
    ...(fgProductsAndBatchInfo || []),
    ...(productsAndBatchInfo || []),
  ]?.reduce((sum, productInfo) => (
    sum
        + (productInfo?.product_batches || []).reduce((batchSum, batchInfo) => batchSum + Number(batchInfo?.copies || 0), 0)
  ), 0), [fgProductsAndBatchInfo, productsAndBatchInfo]);
  const closeAndReset = () => {
    toggleModal();
    setResetCopies(!resetCopies);
    printLabelsSuccess(null);
  };

  return (
    <Fragment>
      <Drawer
        open={isModalOpen}
        width="850px"
        onClose={closeAndReset}
        destroyOnClose
      >

        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '800px' }}>
            <H3Text text="Download Labels" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={closeAndReset}
            />
          </div>
        </div>
        <div className="flex-align-space-between" style={{ gap: '10px' }}>
          <div>
            <div>
              <label className="orgFormLabel">
                Select Label Template
                <span style={{ color: 'red' }}>{'  *'}</span>
              </label>
              <PRZSelect
                style={{
                  width: 400,
                }}
                value={labelTemplateId}
                onChange={(value) => {
                  setLabelTemplateId(value);
                  setSelectedLabel(labelGeneration?.filter((label) => label?.label_template_id === value)?.[0]);
                }}
                options={
                  labelGeneration?.map((label) => (
                    {
                      value: label?.label_template_id,
                      label: label?.template_name,
                    }
                  ))
                }
              />
            </div>
          </div>
          <div>
            <p style={{ textAlign: 'center' }} className="orgFormLabel">
              Template Preview
            </p>
            {selectedLabel && <GlobalLabelsCard labelsData={selectedLabel} viewOnly />}
          </div>
        </div>
        <Divider />
        <div>
          {!selectedMO && <label className="orgFormLabel">Select Batches</label>}
          {
            (selectedMO && fgProductsAndBatchInfo?.length) && fgProductsAndBatchInfo?.map((data) => (
              <>
              <label className="orgFormLabel">FG Batches</label><Collapse
                bordered={false}
                defaultActiveKey={['0']}
                expandIcon={({ isActive }) => (isActive ? <FontAwesomeIcon icon={faAngleDown} />
                  : <FontAwesomeIcon icon={faAngleRight} />)}
                style={{
                  background: '#00000005',
                  marginBottom: '14px',
                }}
                key={data}
              >
                <Panel
                  header={(
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                      <div>
                        <div
                          style={{ fontSize: '12px' }}
                          onClick={(e) => {
                            e.stopPropagation();
                          } }
                        >
                          <Link to={`/inventory/product/view/${data?.product_sku_id}`} target="_blank">
                            {`#${data?.internal_sku_code}`}
                          </Link>
                        </div>
                        <div>
                          {`${data?.product_sku_name}`?.trim()}
                        </div>
                      </div>
                      <div style={{ marginRight: '7px' }}>
                        <div className="orgFormLabel">Copies</div>
                        <InputNumber
                          type="number"
                          min={0}
                          defaultValue={0}
                          changeOnWheel={false}
                          controls={false}
                          style={{
                            width: 200,
                          }}
                          formatter={(value) => `${value}`.replace(/[^0-9]/g, '')}
                          parser={(value) => value.replace(/[^\d]/g, '')}
                          onClick={(e) => {
                            e.stopPropagation();
                          } }
                          onChange={(value) => {
                            handleChangeProductCopies(value, data?.key);
                          } } />
                      </div>
                    </div>
                  )}
                  key="1"
                >
                  <Table
                    columns={getBatchInfoColumns()}
                    size="small"
                    scroll="scroll"
                    loading={getLabelGenerationLoading}
                    dataSource={getBatchInfoData(data?.product_batches, data?.key) || []}
                    pagination={false} />
                </Panel>
              </Collapse></>
            ))
          }
          {
            productsAndBatchInfo?.length>0 && productsAndBatchInfo?.map((data) => (
            <>
            {selectedMO ? <label className="orgFormLabel">RM Batches</label>:''}
            <Collapse
                bordered={false}
                defaultActiveKey={['0']}
                expandIcon={({ isActive }) => (isActive ? <FontAwesomeIcon icon={faAngleDown} />
                  : <FontAwesomeIcon icon={faAngleRight} />)}
                style={{
                  background: '#00000005',
                  marginBottom: '14px',
                }}
                key={data}
              >
                <Panel
                  header={(
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                      <div>
                        <div
                          style={{ fontSize: '12px' }}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <Link to={`/inventory/product/view/${data?.product_sku_id}`} target="_blank">
                            {`#${data?.internal_sku_code}`}
                          </Link>
                        </div>
                        <div>
                          {`${data?.product_sku_name}`?.trim()}
                        </div>
                      </div>
                      <div style={{ marginRight: '7px' }}>
                        <div className="orgFormLabel">Copies</div>
                        <InputNumber
                          type="number"
                          min={0}
                          defaultValue={0}
                          changeOnWheel={false}
                          controls={false}
                          style={{
                            width: 200,
                          }}
                          formatter={(value) => `${value}`.replace(/[^0-9]/g, '')}
                          parser={(value) => value.replace(/[^\d]/g, '')}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          onChange={(value) => {
                            handleChangeProductCopies(value, data?.key);
                          }} 
                          />
                      </div>
                    </div>
                  )}
                  key="1"
                >
                  <Table
                    columns={getBatchInfoColumns()}
                    size="small"
                    scroll="scroll"
                    loading={getLabelGenerationLoading}
                    dataSource={getBatchInfoData(data?.product_batches, data?.key) || []}
                    pagination={false} />
                </Panel>
              </Collapse>
              </>
            ))
          }

        </div>
        {printedLabels && (
          <div className="print-label__success">
            <div className="print-label__success-image">
              <Lottie
                animationData={successLottie}
                loop
              />
            </div>
            <div className="print-label__success-text">
              The Label for selected batches are now ready.
              <div>
                <span onClick={() => {
                  const data = `${printedLabels}`;
                  const myWindow = window.open('', '_blank');
                  myWindow.document.write(data);
                }}
                >
                  Click here
                </span>
                &nbsp; to print the labels.
              </div>
            </div>
          </div>
        )}

        <div className="custom-drawer__footer" style={{ width: '100%' }}>
          <Button
            key="print"
            type="primary"
            disabled={!labelTemplateId || !countBatchCopies}
            loading={printLabelsLoading}
            onClick={() => {
              const batchCopiesData = [...fgProductsAndBatchInfo,...productsAndBatchInfo]?.reduce((acc, data) => {
                const productBatchCopiesData = data?.product_batches?.reduce((prev, curr) => (curr?.copies > 0 ? {
                  ...prev,
                  [curr?.batch_id]: curr?.copies,
                } : prev), {});
                return {
                  ...acc, ...productBatchCopiesData,
                };
              }, {});

              printLabels({
                documentId,
                entityName: documentType,
                labelTemplateId,
                batchCopiesData,
                batchConfig: selectedLabel?.batch_config,
              }, (printedLabelsHtml) => {
                const data = `${printedLabelsHtml}`;
                const myWindow = window.open('', '_blank');
                myWindow.document.write(data);
              });
            }}
          >
            Print
          </Button>
        </div>
      </Drawer>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, LabelGenerationReducers, AnalyticsReducers,
}) => ({
  user: UserReducers.user,
  labelGeneration: LabelGenerationReducers.labelGeneration,
  getLabelGenerationLoading: LabelGenerationReducers.getLabelGenerationLoading,
  printLabelsLoading: AnalyticsReducers.printLabelsLoading,
  printedLabels: AnalyticsReducers.printedLabels,
});

const mapDispatchToProps = (dispatch) => ({
  getLabelGeneration: (payload, document) => dispatch(LabelGenerationActions.getLabelGeneration(payload, document)),
  downloadDocument: (payload, document) => dispatch(AnalyticsActions.downloadDocument(payload, document)),
  printLabels: (payload, callback) => dispatch(AnalyticsActions.printLabels(payload, callback)),
  printLabelsSuccess: (printedLabels) => dispatch(AnalyticsActions.printLabelsSuccess(printedLabels)),

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DownloadLabels));
